import { useState } from 'react';
import BankSearch from './BankSearch';
import ManualAdd from './ManualAdd';

type Props = {
  open: boolean;
  onClose: () => void;
  bankAccountId?: string;
  manualEntry?: boolean;
};

const AddNewBankAccount: React.FC<Props> = ({
  open,
  onClose,
  bankAccountId,
  manualEntry,
}) => {
  const [addWithoutFeed, setAddWithoutFeed] = useState(false);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <BankSearch
        open={open && !addWithoutFeed}
        onClose={handleClose}
        onAddManually={() => setAddWithoutFeed(true)}
        transitionDuration={{ exit: 0 }}
        bankAccountId={bankAccountId}
      />
      <ManualAdd
        open={(open && addWithoutFeed) || Boolean(manualEntry)}
        onClose={handleClose}
        onCancel={() => (manualEntry ? onClose() : setAddWithoutFeed(false))}
        transitionDuration={{ exit: 0 }}
      />
    </>
  );
};

export default AddNewBankAccount;
